import { trackLead } from './lead-analytics-client';

export interface LeadContext {
  sourceProduct: string;
  productPage: string;
  expiresAt: number;
}

const contextKey = (market: string) => `vaderstad-lead-context:${market}`;
export const summaryKey = 'vaderstad-lead-summary';
export const summaryLifetime = 30 * 60 * 1000;

export function readStored<T>(storage: Storage, key: string): T | null {
  try { return JSON.parse(storage.getItem(key) ?? 'null') as T | null; }
  catch { return null; }
}

export function getLeadContext(market: string): LeadContext {
  let saved: LeadContext | null = null;
  try { saved = readStored<LeadContext>(localStorage, contextKey(market)); } catch { /* Storage unavailable. */ }
  if (saved && saved.expiresAt > Date.now() && typeof saved.sourceProduct === 'string' && typeof saved.productPage === 'string') {
    return { sourceProduct: saved.sourceProduct, productPage: saved.productPage, expiresAt: saved.expiresAt };
  }
  return { sourceProduct: '', productPage: '', expiresAt: Date.now() + 24 * 60 * 60 * 1000 };
}

export function saveLeadContext(market: string, context: LeadContext): void {
  try { localStorage.setItem(contextKey(market), JSON.stringify(context)); } catch { /* URL prefill remains available. */ }
}

export function clearLeadContext(market: string): void {
  try { localStorage.removeItem(contextKey(market)); } catch { /* Storage unavailable. */ }
}

// Imported by the form and CTA assets. Bind each anchor only once.
for (const anchor of document.querySelectorAll<HTMLAnchorElement>('[data-lead-cta]')) {
  const market = anchor.dataset.leadMarket ?? '';
  const context = getLeadContext(market);
  if (anchor.dataset.leadSource === 'product') {
    context.sourceProduct = anchor.dataset.leadProduct ?? '';
    context.productPage = location.pathname;
    saveLeadContext(market, context);
  }
  if (anchor.dataset.leadBound) continue;
  anchor.dataset.leadBound = 'true';
  anchor.addEventListener('click', () => {
    trackLead('lead_cta_click', { placement: anchor.dataset.leadPlacement ?? '', source: anchor.dataset.leadSource ?? '', market });
  });
}
